import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import StatsBar from './components/StatsBar';
import Features from './components/Features';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import DownloadCTA from './components/DownloadCTA';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '豆花视频',
      url: 'https://www.douhuavideo.com',
      description: '豆花视频是正版高清视频平台，提供海量影视、综艺、短视频内容',
      sameAs: [
        'https://weibo.com/douhuavideo',
        'https://www.douyin.com/douhuavideo',
      ],
    },
    {
      '@type': 'WebSite',
      name: '豆花视频官网',
      url: 'https://www.douhuavideo.com',
      potentialAction: {
        '@type': 'SearchAction',
        'target': 'https://www.douhuavideo.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '豆花视频官网 - 官方正版视频平台',
      description: '豆花视频官网是您观看正版高清视频的首选平台，提供海量影视、综艺、短视频内容，支持多端同步播放。',
      url: 'https://www.douhuavideo.com',
      isPartOf: { '@type': 'WebSite', name: '豆花视频官网' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '豆花视频会员有哪些权益？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '豆花视频会员可享受免广告观看、超高清4K画质、VIP专享内容、离线缓存、多端同步播放等多项专属权益。',
          },
        },
        {
          '@type': 'Question',
          name: '如何下载豆花视频APP？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以在苹果App Store、华为应用市场等各大应用商店搜索"豆花视频"下载。',
          },
        },
        {
          '@type': 'Question',
          name: '豆花视频支持哪些设备观看？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '豆花视频支持手机、平板、电脑网页端以及智能电视观看，同一个账号可在多个设备上登录使用。',
          },
        },
        {
          '@type': 'Question',
          name: '视频加载缓慢怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '建议您检查网络连接状态，可以尝试切换清晰度。如果问题依旧，请尝试清除APP缓存或联系客服。',
          },
        },
        {
          '@type': 'Question',
          name: '如何取消自动续费？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以在豆花视频APP中进入"我的"→"会员中心"→"管理自动续费"进行取消操作。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedVideos />
        <StatsBar />
        <Features />
        <ArticlesSection />
        <FAQSection />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}